// frontend/src/components/PaymentSuccess.js (NEW FILE)
import React, { useEffect, useContext } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthContext } from "../App"; // To potentially refresh user data

function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const { user, authToken, saveToken } = useContext(AuthContext); // Get context

  // Optional: You could verify the session with your backend here
  // or simply rely on the webhook to update the user's plan eventually.
  // For immediate feedback, fetching user data again might be good.
  useEffect(() => {
    // Example: Re-fetch user data after successful payment
    const reFetchUser = async () => {
      if (authToken) {
        try {
          const response = await fetch("http://localhost:8000/api/users/me", {
            headers: { Authorization: `Bearer ${authToken}` },
          });
          if (response.ok) {
            const userData = await response.json();
            // You might need to update the context/state more directly
            // depending on your AuthContext implementation
            console.log("Refetched user data after payment:", userData);
            // This might trigger a re-render if App.js useEffect depends on 'user' object identity
            // Or update context directly: authContext.setUser(userData);
          }
        } catch (error) {
          console.error("Error re-fetching user after payment:", error);
        }
      }
    };
    // Give webhook some time, then refetch
    const timer = setTimeout(() => reFetchUser(), 2000); // Wait 2s
    return () => clearTimeout(timer);
  }, [authToken, saveToken]); // Add dependencies

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h1>Payment Successful!</h1>
      <p>Thank you for upgrading to GrandmasterAI Premium!</p>
      {sessionId && (
        <p style={{ fontSize: "0.8em", color: "#666" }}>
          Session ID: {sessionId}
        </p>
      )}
      <p>
        Your account has been upgraded. You can now access premium features.
      </p>
      <Link
        to="/dashboard"
        style={{
          marginTop: "20px",
          display: "inline-block",
          padding: "10px 20px",
          backgroundColor: "#28a745",
          color: "white",
          textDecoration: "none",
          borderRadius: "5px",
        }}
      >
        Go to Dashboard
      </Link>
    </div>
  );
}

export default PaymentSuccess;
